import React, { useState, useEffect } from 'react';
import { CheckboxInputStyled } from './styled';
export function CheckboxInput(props) {
    const { disabled = false, checked = false, defaultChecked = false, isRightToLeft = false, required, onClick, onChange, value, hasMultipleChecked, theme, id, } = props;
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const onClickHandler = (event) => onClick && onClick(event);
    const onChangeHandler = (e) => {
        setCheckboxChecked(e.target.checked);
        if (disabled) {
            return;
        }
        if (onChange) {
            onChange({
                target: {
                    ...props,
                    checked: e.target.checked,
                    value: value || undefined,
                },
                stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault() {
                    e.preventDefault();
                },
                nativeEvent: e.nativeEvent,
            });
        }
    };
    useEffect(() => {
        setCheckboxChecked(() => ('checked' in props ? checked : defaultChecked));
    }, [checked, defaultChecked, props]);
    return (React.createElement(CheckboxInputStyled, { type: "checkbox", id: id, checked: checkboxChecked, required: required, disabled: disabled, hasMultipleChecked: hasMultipleChecked, theme: theme, onClick: onClickHandler, onChange: onChangeHandler, value: value, isRightToLeft: isRightToLeft }));
}
CheckboxInput.displayName = 'CheckboxInput_Component';
